import {ReactElement} from 'react';
import {useAlert} from 'react-alert';
import {useForm, SubmitHandler} from 'react-hook-form';

import {useSubscribe} from '~/hooks/account/useSubscribe';

interface IFormInput {
  email: string;
}

export function SubscriptionSection(): ReactElement {
  const subscribe = useSubscribe();
  const alert = useAlert();
  const {
    register,
    handleSubmit,
    formState: {isSubmitting},
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = async (values) => {
    await subscribe.mutate({email: values.email}, {});
    alert.success('Please check your email for confirmation');
    reset();
  };

  return (
    <div
      className="bg-sage-600 px-8 py-12 md:px-32 md:py-24"
      id="subscription-section"
    >
      <div className="flex flex-col items-center justify-center gap-8">
        <div className="w-3/4 text-center text-[32px] leading-none text-pinksalt-200  md:text-[54px]">
          Let&apos;s be <span className="font-serif italic">friends</span>, but
          like, over the
          <span className="font-serif italic"> internet</span>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex w-full items-center justify-center"
        >
          <div className="grid w-4/5 grid-cols-1 gap-y-2 md:w-2/4 md:grid-cols-3 md:gap-x-2">
            <input
              {...register('email', {required: true})}
              type="email"
              placeholder="Your email"
              className="focus-visible:ring-none col-span-2 w-full rounded-full px-6 py-4 text-sm focus:outline-none"
              required
            />
            <button
              type="submit"
              className="rounded-full bg-daybreak-400 px-8 py-4 text-sm text-white"
              disabled={isSubmitting}
            >
              {isSubmitting ? <>Submitting...</> : <>Submit</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
